import React, {useEffect} from "react"
import {useConfirmEmailMutation} from "../query";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import {CircularProgress} from "@mui/material";
import Stack from "@mui/material/Stack";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import MDButton from "../../../materialDashboard/components/MDButton";


const VerifyToken = ({ token }) => {
    const {t} = useTranslation(['auth']);
    const navigate = useNavigate();

    const {mutateAsync, isSuccess, isError} = useConfirmEmailMutation();

    useEffect(() => {
        const confirmEmail = async () => {
            try {
                await mutateAsync({ token });
            } catch (error) {
                console.error("Error confirming email:", error);
            }
        };
        confirmEmail();
    }, []);

    if (isSuccess) {
        return <Stack justifyContent="center" alignItems="center" spacing={2}>
            <MDTypography color="success" align="center" variant="body2">
                {t('emailConfirmation.emailVerified')}
            </MDTypography>
        </Stack>
    }
    if (isError) {
        return <Stack justifyContent="center" alignItems="center" spacing={2}>
            <MDTypography color="error" align="center" variant="body2">
                {t('emailConfirmation.emailNotVerified')}
            </MDTypography>

            <MDButton variant="contained"
                      color="info"
                      onClick={() => navigate('/auth/email-confirmation')}>
                {t('emailConfirmation.requestToken')}
            </MDButton>
        </Stack>
    }

    return <Stack justifyContent="center" alignItems="center" spacing={2}>
        <CircularProgress size={24} color="info" />
        <MDTypography variant="body2">
            {t('emailConfirmation.emailVerificationInProgress')}
        </MDTypography>
    </Stack>
}


export default VerifyToken;